<template>
  <v-app>
    <v-main class="userForm">
      <v-container class="form-container">
        <v-row>
          <v-col class="form-title">
            <span class="header1 header1--blue"> {{ title }} </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="form">
            <slot name="form"></slot>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <p class="copyright-text small-body">
              Este sitio está protegido por reCAPTCHA.<br />
              © Copyright - Universidad Europea del Atlántico 2022.
            </p>
          </v-col>
        </v-row>
      </v-container>
      </v-main>
  </v-app>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            require: true,
            default: "",
        },
    }
}
</script>